import { render, staticRenderFns } from "./tbbjtjzbhxr.vue?vue&type=template&id=a19c276c&scoped=true&"
import script from "./tbbjtjzbhxr.vue?vue&type=script&lang=js&"
export * from "./tbbjtjzbhxr.vue?vue&type=script&lang=js&"
import style0 from "./tbbjtjzbhxr.vue?vue&type=style&index=0&id=a19c276c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19c276c",
  null
  
)

export default component.exports